module.exports = __webpack_public_path__ + "static/img/yd-banner2.463eb56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-banner2.png
// module id = Oips
// module chunks = 0